{
  "name": "npm-package-json-lint",
  "version": "0.0.0",
  "description": "Configurable linter for package.json files.",
  "keywords": [
    "lint",
    "linter",
    "package.json",
    "audit",
    "auditor",
    "npm-package-json-lint"
  ],
  "homepage": "https://github.com/tclindner/npm-package-json-lint",
  "bugs": {
    "url": "https://github.com/tclindner/npm-package-json-lint/issues"
  },
  "author": "Thomas Lindner",
  "repository": {
    "type": "git",
    "url": "https://github.com/tclindner/npm-package-json-lint.git"
  },
  "bin": {
    "npmPkgJsonLint": "dist/cli.js"
  },
  "files": [
    "CONTRIBUTING.md",
    "dist"
  ],
  "main": "dist/api.js",
  "types": "dist/src/api.d.ts",
  "scripts": {
    "build": "npm run esbuild && npm run tsc",
    "esbuild": "node esbuild.config.js",
    "eslint": "eslint . --format=node_modules/eslint-formatter-pretty",
    "npmpackagejsonlint": "node dist/cli.js ./package.json",
    "lint": "npm run eslint && npm run npmpackagejsonlint",
    "test": "npm run build && jest",
    "test:ci": "jest --runInBand",
    "tsc": "tsc --project tsconfig.json"
  },
  "dependencies": {
    "ajv": "^6.12.6",
    "ajv-errors": "^1.0.1",
    "chalk": "^4.1.2",
    "cosmiconfig": "^8.2.0",
    "debug": "^4.3.4",
    "globby": "^11.1.0",
    "ignore": "^5.2.4",
    "is-plain-obj": "^3.0.0",
    "jsonc-parser": "^3.2.0",
    "log-symbols": "^4.1.0",
    "meow": "^9.0.0",
    "plur": "^4.0.0",
    "semver": "^7.5.3",
    "slash": "^3.0.0",
    "strip-json-comments": "^3.1.1",
    "type-fest": "^3.12.0",
    "validate-npm-package-name": "^5.0.0"
  },
  "devDependencies": {
    "@types/jest": "^27.5.0",
    "@types/node": "^20.3.3",
    "@typescript-eslint/eslint-plugin": "^5.61.0",
    "esbuild": "^0.17.19",
    "esbuild-node-externals": "^1.7.0",
    "eslint": "^8.44.0",
    "eslint-config-tc": "^22.2.0",
    "eslint-config-typescript-tc": "^6.0.0",
    "eslint-formatter-pretty": "^5.0.0",
    "eslint-plugin-eslint-comments": "^3.2.0",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-jest": "^27.2.1",
    "eslint-plugin-prettier": "^4.2.1",
    "eslint-plugin-unicorn": "^47.0.0",
    "figures": "^3.2.0",
    "jest": "^27.5.1",
    "npm-package-json-lint-config-default": "^5.0.0",
    "npm-package-json-lint-config-tc": "^6.0.0",
    "prettier": "^2.8.8",
    "ts-jest": "^27.1.4",
    "typescript": "^4.9.5"
  },
  "engines": {
    "node": ">=16.0.0",
    "npm": ">=8.0.0"
  },
  "license": "MIT"
}
